import React from 'react';
import PropTypes from 'prop-types';
import { I18n, Translate } from 'react-redux-i18n';
import { Collapse } from '@material-ui/core';
import { TextSimpleAutocomplete } from 'front-onceforall-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SelectProjectView = props => {
  const suggestions = props.projects.map(project => ({
    label: project.name,
    value: project.id
  }));
  const handleSelectProject = event => {
    const selection = event.target.value;
    if (selection) {
      props.onSelectProject(props.projects.find(project => project.id === selection.value));
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "card",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex-container space-between",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex-container",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "m-0",
          children: /*#__PURE__*/_jsx(Translate, {
            value: "request.create.project.title"
          })
        }), !props.isOpen && /*#__PURE__*/_jsx("div", {
          className: "chip-l information-primary ml-4",
          children: /*#__PURE__*/_jsx(Translate, {
            value: props.project.name
          })
        })]
      }), !props.isOpen && /*#__PURE__*/_jsx("button", {
        "data-id": "changeProjectButton",
        className: "inline-container small secondary",
        onClick: () => props.onSelectProject(null),
        children: /*#__PURE__*/_jsx(Translate, {
          value: "request.create.project.change"
        })
      })]
    }), /*#__PURE__*/_jsxs(Collapse, {
      in: props.isOpen,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "py-4 strong d-flex flex-column",
        children: [/*#__PURE__*/_jsx(Translate, {
          className: "py-2",
          value: 'request.create.project.information1'
        }), /*#__PURE__*/_jsx(Translate, {
          className: "py-2",
          value: 'request.create.project.information2'
        }), /*#__PURE__*/_jsx(Translate, {
          className: "py-2",
          value: 'request.create.project.information3'
        }), /*#__PURE__*/_jsx(Translate, {
          className: "py-2",
          value: 'request.create.project.information4'
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "py-4 strong",
        children: /*#__PURE__*/_jsx(Translate, {
          value: 'request.create.project.notice'
        })
      }), /*#__PURE__*/_jsx(TextSimpleAutocomplete, {
        suggestions: suggestions,
        value: null,
        placeholder: I18n.t(`request.create.project.input${props.loading ? 'Loading' : 'Placeholder'}`),
        onChange: handleSelectProject,
        minimumCharsToRenderResults: 0,
        maxResult: 5,
        disabled: props.loading
      })]
    })]
  });
};
SelectProjectView.propTypes = {
  projects: PropTypes.array.isRequired,
  project: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onSelectProject: PropTypes.func.isRequired
};
export default SelectProjectView;